import { rydeColors } from "@ryde/theme";

export const downloadReportChartCanvasAsPng = ({
  canvas,
  fileName,
}: {
  canvas: HTMLCanvasElement;
  fileName: string;
}): void => {
  const width = canvas.width;
  const height = canvas.height;
  const offscreen = document.createElement("canvas");
  offscreen.width = width;
  offscreen.height = height;
  const context = offscreen.getContext("2d");

  if (!context) {
    return;
  }

  context.fillStyle = rydeColors.white;
  context.fillRect(0, 0, width, height);
  context.drawImage(canvas, 0, 0);

  const url = offscreen.toDataURL("image/png");
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
};

export const buildReportChartExportFileName = ({
  reportTitle,
}: {
  reportTitle?: string;
}): string => {
  const base = (reportTitle || "report-chart")
    .trim()
    .replace(/[^\w-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();

  return `${base || "report-chart"}.png`;
};
